import { authProvider } from "../context/authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { ListadeHorarios } from "./ListadeHorarios";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const VistaHorarios = () => {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <BtnGoBack caption="Volver a inicio" border={false} />
                </div>
              </div>

              <div className="horarios-page__content">
                <ListadeHorarios />
              </div>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
